module.exports = __webpack_public_path__ + "img/jointpain.102f6204.svg";